import { CartScreen } from 'features/cart/cart-screen';

import { useRumPageView } from 'hooks/rum/use-rum-page-view';
import { useEnableUnifiedMenu } from 'hooks/use-enable-unified-menu';
import { Cart } from 'pages/cart/cart';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

export default function CartPage() {
  useRumPageView('cart', 'Cart');
  const enableMinimalCartUI = useFlag(LaunchDarklyFlag.ENABLE_MINIMAL_CART_UI);
  const isUnifiedMenuEnabled = useEnableUnifiedMenu();
  if (enableMinimalCartUI && isUnifiedMenuEnabled) {
    return <CartScreen />;
  }
  return <Cart />;
}
